import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module,
	Button,
} from 'ps-gui';

import {
	CellMainText,
	CellSubText
} from '../portalresultsetmodule';

import $ from 'jquery';

import {
	ModuleBodySection,
	ModuleHeaderSection,
	ModuleHeader,
	ModuleHeaderBlock
} from '../../blocks/modulesections';

import AffirmationSubmissionModel, { getDistributionYearFromModelData } from './affirmationsubmissionmodel';
import { getPhrase } from '../../data/phrases';
import { getGlobalContextChangeChecker } from '../utils';

import { ReactComponent as ModuleLogo } from '../../svg/submission.svg';
import { GlobalContext, withGlobalContext } from '../../data/globalcontext';

import {StatusBubble} from '../submissioncomponents';
import Tooltip from '../../components/tooltip';
import { getTooltipMarkup } from './tooltips';


const Wrapper = styled.div`
	z-index: 0;
	.ps-moduleContainerContent {
		overflow: visible !important;
	}

	.ps-tabPaneContent {
		overflow: visible !important;
		padding-top: 24px;
	}

	.ps-moduleContainerToolbar {
		background: rgb(251, 251, 251);
		position: sticky;
		top: 0px;
		z-index: 1;
		align-items: baseline;
	}

	.conflictResolution {
		.ps-input.number {
			width: 100%;
		}
	}
`;

const RowCountEtc = styled.div`
	margin-bottom: 24px;
`;

const RowCount = styled.div`
	display: inline-block;
	color: ${props => props.theme.disabledTextColor};
	font-size: 20px;
	margin-right: 40px;
	.label {
		font-weight: 400;
		margin-right: 5px;
	}
	.value {
		font-weight: 900;
	}
`;


class AffirmationSubmissionModule extends ParentBoundComponent {

	constructor() {
		super();
		this.setRoleId = this.setRoleId.bind(this);
		this.setDistributionPeriodId = this.setDistributionPeriodId.bind(this);
		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
		this.newSubmission = this.newSubmission.bind(this);
		this.ref = React.createRef();
		this.mouseenter = this.mouseenter.bind(this);
		this.mouseleave = this.mouseleave.bind(this);
		this.mousedown = this.mousedown.bind(this);
	}

	getModel() {
		return new AffirmationSubmissionModel(this.getData());
	}

	async newSubmission() {
		this.setModel(await this.getModel().openNewSubmission());
	}

	hideTooltip() {
		const data = this.getData();
		if (data.get('tooltipAnchor')) {
			this.setData(data.set('tooltipAnchor', null));
		}
	}

	showTooltip(anchorElement) {
		let markup = getTooltipMarkup(anchorElement.getAttribute('data-ttk'));
		if (markup) {
			const data = this.getData();
			const distYear = getDistributionYearFromModelData(data);
			markup = markup.replaceAll('$distributionYear', distYear);
			this.setData(data.set('tooltipAnchor', anchorElement.getBoundingClientRect()).set('tooltipMarkup', markup));
		}
	}

	mousedown(e) {
		this.hideTooltip();
	}

	mouseenter(e) {
		this.showTooltip(e.target);
	}

	mouseleave(e) {
		this.hideTooltip();
	}


	async setRoleId(value) {
		let model = this.getModel().setRoleId(value);
		this.setModel(await model.loadData());
	}

	async setDistributionPeriodId(value) {
		let model = this.getModel().setDistributionPeriodId(value);
		this.setModel(await model.loadData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		this.checkGlobalContextChange();

		let $root = $(this.ref.current);
		$root.on('mouseenter', '[data-ttk]', this.mouseenter);
		$root.on('mouseleave', '[data-ttk]', this.mouseleave);
		$root.on('mouseup', '[data-ttk]', this.mousedown);
	}

	componentWillUnmount() {
		let $root = $(this.ref.current);
		$root.off('mouseleave');
		$root.off('mouseenter');
		$root.off('mouseup');
	}


	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	render() {
		const data = this.getData();
		// console.log(data.toJS());
		const model = this.getModel();
		const tooltipAnchor = data.get('tooltipAnchor');
		return (
			<Wrapper ref={this.ref}>
				<ModuleHeaderSection className="noBorder">
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('AffirmationSubmission')}</ModuleHeader>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				<ModuleBodySection top="-16px">
					{
						!model.isDetailOpen() && (
							<>
								<RowCount>
									<span className="label">{getPhrase('submissionCount')}:</span>
									<span className="value">{data.getIn([
										'esad',
										'data',
										'search',
										'data',
										'result',
										'data',
										'pager',
										'totalCount'
									])}</span>
								</RowCount>
								<Button
									type="full"
									iconName="add"
									text={getPhrase('newSubmission')}
									onAction={this.newSubmission}
								/>
							</>
						)
					}
					<RowCountEtc>
					</RowCountEtc>
					<Module
						appState={data.get('esad')}
						onDataChange={newData => {
							this.setData(data.setIn(['esad', 'data'], newData));
						}}
						customResultProps={customResultProps}
					/>
				</ModuleBodySection>
				{
					tooltipAnchor && (
						<Tooltip
							markup={data.get('tooltipMarkup')}
							anchor={tooltipAnchor}
						/>
					)
				}
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'role_id': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText className="secondary">{cell}</CellMainText>
				<CellSubText>{row.get('role_type')}</CellSubText>
			</>
		);
	},
	'distribution_period': (cell, row, colIndex) => {
		return (
			<CellMainText>{cell}</CellMainText>
		);
	},
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'status': (cell, row) => {
		return (
			<StatusBubble className={row.get('status_id')}>{cell}</StatusBubble>
		);
	},
	'edited_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('edited_by')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: false,
	defaultColumnWidths: {
		'country': '100px',
		'attendance': '110px',
		'status': '180px',
		'release_date': '110px'
	},
	columnFilters: {
		'distribution_period': {
			type: 'lookup',
			lookup: 'affirmationDistributionPeriod'
		},
		'cinema_attendance_record_count': {
			type: 'number',
			inputSize: 10,
		},
		'broadcast_record_count': {
			type: 'number',
			inputSize: 10,
		},
		'sale_record_count': {
			type: 'number',
			inputSize: 10,
		},
		'status': {
			type: 'lookup',
			lookup: 'submissionStatus'
		},
		'role_id': {
			type: 'lookup',
			lookup: 'affirmationSubmissionPartyRole'
		}
	}
};

AffirmationSubmissionModule.contextType = GlobalContext;


export default withGlobalContext(AffirmationSubmissionModule);
